import {
  Component,
  DoCheck,
  EventEmitter,
  Input, IterableDiffer,
  IterableDiffers,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges, ViewChild
} from '@angular/core';
import { ICamp } from '../../model/camp.model';
import { Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { CampService } from '../../service/camp.service';
import { filterOkMapBody } from '../../util/http.utils';
import {
  CampModuleEnum,
  StatutCampEnum,
  TypeCampGroupEnum,
  TooltipIconSymbolEnum,
  TooltipIconTextEnum,
  TypeAvisEnum,
  TypeCampEnum,
  TypeDossierEnum
} from '../../constant/enum';
import { convertToHumanDate } from '../../util/moment.utils';
import {
  getCampMarkerClass,
  getIconMarin,
  getNombreCampDiscussionSujetsOuverts,
  getStructureOrginisatrice,
  getStructuresParticipantes,
  getValidationStatus,
  isCampModulesActive
} from '../../util/camp-utils';
import { getDdcAdherentSoutienIcon } from '../../util/adherent-utils';
import { ITamRefPays } from '../../model/tam-ref-pays.models';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { ISortParams } from '../../model/sort-params.model';
import {MatMenuTrigger} from "@angular/material/menu";
import {result} from "lodash";

@Component({
    selector: 'ddc-camps-information-table',
    templateUrl: './camps-information-table.component.html',
    styleUrls: ['./camps-information-table.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false
})
export class CampsInformationTableComponent implements OnInit, OnChanges, DoCheck {

  @Input() set camps(camps: ICamp[]) {
    this._camps = camps;
  }

  @Input() set campDisplayedColumns(campDisplayedColumns: string[]) {
    this._campsDisplayedColumns = campDisplayedColumns;
  }

  @Input() set listePays(listePays: ITamRefPays[]) {
    this._listePays = listePays;
  }

  @Input() set isSaving(isSaving: boolean) {
    this._isSaving = isSaving;
  }

  @Output() deleteRecord = new EventEmitter();

  @Output() updateSortParams = new EventEmitter();

  campsTableDataSource = new MatTableDataSource<ICamp>([]);

  _camps: ICamp[] = [];
  _campsDisplayedColumns: string[];
  _listePays: ITamRefPays[];
  _isSaving: boolean;

  CampModuleEnum = CampModuleEnum;
  StatutCampEnum = StatutCampEnum;
  TypeCampGroupEnum = TypeCampGroupEnum;
  TooltipIconSymbolEnum = TooltipIconSymbolEnum;
  TooltipIconTextEnum = TooltipIconTextEnum;
  TypeAvisEnum = TypeAvisEnum;
  TypeCampEnum = TypeCampEnum;
  TypeDossierEnum = TypeDossierEnum;

  convertToHumanDate = convertToHumanDate;
  getValidationStatus = getValidationStatus;
  isCampModulesActive = isCampModulesActive;
  getIconMarin = getIconMarin;
  getCampMarkerClass = getCampMarkerClass;
  getStructureOrginisatrice = getStructureOrginisatrice;
  getStructuresParticipantes = getStructuresParticipantes;
  getNombreCampDiscussionSujetsOuverts = getNombreCampDiscussionSujetsOuverts;
  getDdcAdherentSoutienIcon = getDdcAdherentSoutienIcon;

  campsDetails: ICamp[] = [];
  expandedCampDetails = [];
  expandedElement: ICamp;
  iterableDiffer: IterableDiffer<ICamp>;

  constructor(
    protected campService: CampService,
    protected router: Router,
    protected iterableDiffers: IterableDiffers
  ) {
    this.iterableDiffer = iterableDiffers.find(this._camps).create(null)
  }

  ngOnInit(): void {
    this.initCampsTableDataSource();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.initCampsTableDataSource();
  }

  ngDoCheck(): void {
    const changes = this.iterableDiffer.diff(this._camps);
    if (changes) {
      this.initCampsTableDataSource();
    }
  }

  initCampsTableDataSource() {
    this.campsTableDataSource.data = this._camps || [];
  }

  toggleCampDetailsVisibility(camp: ICamp) {
    if (this.expandedCampDetails.includes(camp.id)) {
      const index = this.expandedCampDetails.indexOf(camp.id);
      if (index != -1) {
        this.expandedCampDetails.splice(index, 1);
      }
    } else {
      const campWithDetails = this.getCampWithDetails(camp);
      if (!campWithDetails) {
        this.campService.findOneByIdAndModuleCode(camp.id)
          .pipe(filterOkMapBody)
          .subscribe((campWithDetails: ICamp) => {
            this.campsDetails.push(campWithDetails);
            this.expandedCampDetails.push(camp.id);
          })
      } else {
        this.expandedCampDetails.push(camp.id);
      }
    }
  }

  isCampDetailsExpanded(camp: ICamp) {
    return this.expandedCampDetails.includes(camp.id);
  }

  getCampWithDetails(camp: ICamp): ICamp {
    return this.campsDetails.find((campWithDetails: ICamp) => campWithDetails.id == camp.id);
  }

  /*getPaysForModuleInternational(camp: ICamp) {
    if (camp && camp.campModuleInternational && camp.campModuleInternational.tamRefPays && camp.campModuleInternational.tamRefPays.id) {
      return this._listePays ? this._listePays.find((tamRefPays: ITamRefPays) => tamRefPays.id == camp.campModuleInternational.tamRefPays.id) : '';

    }
    return '';
  }*/

  accessCamp(camp: ICamp ) {
    if (camp && camp.id) {
        this.router.navigate([`/camp/${camp.id}`])
    }
  }



  _deleteRecord(campId) {
    this.deleteRecord.emit(campId);
  }

  _updateSortParams(sortEvent: MatSort) {
    const sortParams: ISortParams = { sortBy: sortEvent.active, sortDirection: sortEvent.direction };
    this.updateSortParams.emit(sortParams);
  }

}
